const PROMOCODE_PREFIX = '@PROMOCODE';

export const FETCH = `${PROMOCODE_PREFIX}/FETCH`;
export const FETCH_SUCCESS = `${PROMOCODE_PREFIX}/FETCH_SUCCESS`;
export const FETCH_ERROR = `${PROMOCODE_PREFIX}/FETCH_ERROR`;
export const RESET_RESULT = `${PROMOCODE_PREFIX}/RESET_RESULT`;
